









import { Component, Vue } from 'vue-property-decorator';
import VideoPlayer from '@/components/VideoPlayer.vue';
import PanningViewport from '@/components/PanningViewport.vue';
import GameLogic from '@/services/GameLogic';
import LocaleService from "../services/LocaleService";

@Component({
    computed: {
        getVideoUrl(): string {
            return this.$store.getters.currentSlotVideo;
        }
    },
    components: {
        VideoPlayer, PanningViewport
    },
    methods: {
        handleVideoEnded(): void {
            GameLogic.nextDay(this.$router, this.$store);
        },
    }
})
export default class DayEnd extends Vue {
}
